<template>
  <b-container>
    <b-button size="sm" class="btn_detailedFilter" @click="modalOpen">{{
      $t("geral.detailedFilter")
    }}</b-button>
    <b-modal
      id="modal-scrollable"
      class="detailedFilter-modal"
      scrollable
      size="lg"
      ref="openModal"
      :title="$t('geral.detailedFilter')"
      @ok="modalOk"
    >
      <label>Formulário: </label>
      <b-form-select
        v-model="form"
        id="optionFilterDate"
        :options="optionsForm"
      >
      </b-form-select>
      <div v-if="form != null">
        <b-col v-for="field in firstLevelFields" :key="field.id">
          <!-- {{field}} -->
          <b-form-group
            v-if="
              field.tipo != 10 &&
              field.tipo != 9 &&
              field.tipo != 8 &&
              field.tipo != 1
            "
            :label="field.nome"
            label-for="input-razaoSocial"
          >
            <b-form-input
              v-if="field.tipo == 6"
              type="text"
              :id="field.nome"
              :placeholder="field.nome"
              v-model="field.defaultValue"
            />
            <b-form-input
              v-if="field.tipo == 5"
              type="number"
              :id="field.nome"
              :placeholder="field.nome"
              v-model="field.defaultValue"
            />
            <b-form-input
              v-if="field.tipo == 2"
              type="date"
              :id="field.nome"
              v-model="field.defaultValue"
            />
            <b-form-input
              v-if="field.tipo == 3"
              type="time"
              :id="field.nome"
              v-model="field.defaultValue"
            />
            <b-form-input
              v-if="field.tipo == 4"
              :id="field.nome"
              type="text"
              :placeholder="field.nome"
              v-mask="'money'"
              v-model="field.defaultValue"
            />
            <b-form-select
              v-if="field.tipo == 7"
              :options="field.options"
              v-model="field.defaultValue"
            >
            </b-form-select>
            <b-form-input
              v-if="field.tipo >= 999"
              type="text"
              :id="field.nome"
              :placeholder="field.nome"
              v-model="field.defaultValue"
            />
            <!-- {{field.defaultValue}} -->
          </b-form-group>
        </b-col>
      </div>

      <template #modal-footer="{ ok, cancel }">
        <div class="right">
          <b-button variant="green" @click="ok()">
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel()">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
        <div class="left">
          <b-button @click="cleanFilter"> Limpar Filtro </b-button>
        </div>
      </template>
    </b-modal>

    <!-- <div>{{firstLevelFields}}</div> -->
    <!-- <div>{{ form }}</div> -->
    <!-- <div>{{fields}}</div> -->
  </b-container>
</template>
<script>
import AwesomeMask from "awesome-mask";
export default {
  name: "BaseDetailedFilter",
  components: {
    ChecklistFill: () =>
      import("@/components_rms/checklist/fill/ChecklistFill.vue"),
  },
  props: {
    fields: Array,
    formName: String,
  },
  directives: {
    mask: AwesomeMask,
  },
  data: function () {
    return {
      optionsForm: [],
      form: "",
      firstLevelFields: [],
      formId: "",
      getFormName: "",
    };
  },
  created() {
    this.getAllForms();
    this.getFilterApplied();
  },
  computed: {},
  methods: {
    modalOpen() {
      this.$refs.openModal.show();
    },
    getAllForms() {
      this.$apiChecklist
        .get("/detailedFilter/GetAllForm/")
        .then((response) => {
          this.optionsForm = response.data;
        })
        .catch((error) => {
          // console.log(error.response);
          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
    getAllfields() {
      this.$apiChecklist
        .get("/detailedFilter/GetAllFirstlevelFields/" + this.form)
        .then((response) => {
          console.log("response");
          console.log(response);
          if (this.firstLevelFields.length == 0 || this.form != this.formId) {
            let checklist = response.data;
            this.firstLevelFields = checklist;
            this.optionsForm.forEach((options) => {
              if (options.value == this.form) this.getFormName = options.text;
            });
            // console.log(this.firstLevelFields);
            this.$emit("update:fields", this.firstLevelFields);
            this.$emit("update:formName", this.getFormName);
            this.$forceUpdate();
          } else {
            this.getFilterApplied();
            this.optionsForm.forEach((options) => {
              if (options.value == this.form) this.getFormName = options.text;
            });
            this.$emit("update:fields", this.firstLevelFields);
            this.$emit("update:formName", this.getFormName);
            this.$forceUpdate();
          }
        })
        .catch((error) => {
          console.log(error.response);
          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
    async postFilterApplied() {
      let filters = {
        formId: this.form,
        appliedFilters: JSON.stringify(this.firstLevelFields),
      };
      this.$apiChecklist
        .post("/detailedFilter/saveFilterApplied/", filters)
        .then((response) => {
          this.firstLevelFields = JSON.parse(response.data.appliedFilters);
          this.$emit("update:fields", this.firstLevelFields);
          this.$emit("update:formName", this.getFormName);
          this.$forceUpdate();
        })
        .catch((error) => {
          console.log("Error ");
          console.log(error);
          console.log(error.response.data.errors);
        });
    },
    getFilterApplied() {
      this.$apiChecklist
        .get("/detailedFilter/filtersApplied/")
        .then((response) => {
          // console.log(response);
          let model = JSON.parse(response.data.appliedFilters);
          this.firstLevelFields = model;
          this.form = response.data.formId;
          this.formId = this.form;
          this.optionsForm.forEach((options) => {
            if (options.value == this.form) this.getFormName = options.text;
          });
          this.$emit("update:fields", this.firstLevelFields);
          this.$emit("update:formName", this.getFormName);
          // this.$emit("update:fields", this.firstLevelFields);
          this.$forceUpdate();
        })
        .catch((error) => {
          console.log("Error ");
          console.log(error);
          console.log(error.response.data.errors);
        });
    },
    cleanFilter() {
      this.form = "";
      this.firstLevelFields = [];
      this.getFormName = "";
      this.$emit("update:fields", this.firstLevelFields);
      this.$emit("update:formName", this.getFormName);
      this.postFilterApplied();
    },
    modalOk() {
      this.postFilterApplied();
      this.$emit("update:fields", this.firstLevelFields);
      this.$emit("update:formName", this.getFormName);
      this.$forceUpdate();
    },
  },
  watch: {
    form() {
      if (this.form != "" && this.form != this.formId) this.getAllfields();
    },
  },
};
</script>
<style>
.btn_detailedFilter {
  text-align: right;
  margin-left: 85%;
}
.right {
  text-align: right;
  width: 100%;
}
.left {
  margin-top: -6%;
  text-align: left;
  width: 100%;
}
</style>
